import React, { useState } from "react";
import { Font } from "@react-pdf/renderer";
import logo from "../../assests/AGP_Logo.png";
import { getDataFormatBr, addLeadingZeros } from "../../utils/DataUtils";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  pdf,
} from "@react-pdf/renderer";

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-700.ttf",
      fontWeight: "bold",
    },
  ],
});

const styles = StyleSheet.create({
  table: {
    display: "table",
    width: "98%",
    marginBottom: 10,
    marginLeft: 10,
  },
  tableRow: {
    flexDirection: "row",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: 5,
  },
  tableBorder: {
    display: "table",
    width: "100%",
    border: 1,
    borderColor: "black",
  },
  columnHeader: {
    flexDirection: "row",
    display: "flex",
    flexWrap: "wrap",
    textAlign: "center",
    fontSize: 8,
  },
  columnHeaderText: {
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },
  text: {
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "Open Sans",
  },
  textPadding: {
    fontSize: 9,
    padding: 2,
    fontWeight: "normal",
    overflowWrap: "break-word",
  },
  textBorder: {
    padding: 2,
    fontSize: 9,
    width: "30%",
    borderRightWidth: 1,
    borderColor: "black",
  },
  cell: {
    textAlign: "center",
    fontSize: 8,
    width: "90%",
  },
  page: {
    padding: 20,
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    paddingHorizontal: 10,
    marginVertical: 5,
  },
  sectionText: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  sectionTextHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 5,
  },
  section: {
    padding: 10,
    flexGrow: 1,
  },
  logo: {
    alignSelf: "center",
    width: 70,
    height: 40,
  },
  pageFooter: {
    paddingHorizontal: 40,
    position: "absolute",
    marginTop: 10,
    fontSize: 8,
    bottom: 50,
    textAlign: "left",
  },
  pageFooter2: {
    position: "absolute",
    marginHorizontal: 40,
    backgroundColor: "#cccccc",
    marginTop: 10,
    borderWidth: 1,
    borderBottomColor: "black",
    fontSize: 8,
    bottom: 10,
    textAlign: "left",
  },
  fixedFooter: {
    textAlign: "center",
    fontSize: 8,
    marginTop: "auto",
    height: 60,
  },
});

let sumQtde = "";
let sumNetWeight = "";
let listBox = [];
let firtBox = 0;
let totalWeigthBox = [];
let totalWeigthPack = 0;

const sumValues = (data) => {
  listBox = contarRepeticoes(data);
  sumQtde = somarValores(data, "qtde", true);
  sumNetWeight = somarValores(data, "item_PesoLiquido", true);
  totalWeigthBox = calculateTotalWeights(listBox, data);

  for (let i = 0; i < totalWeigthBox.length; i++) {
    totalWeigthPack += totalWeigthBox[i].boxTotalWeigth;
  }

  totalWeigthPack = Number(totalWeigthPack.toFixed(2));
};

const contarRepeticoes = (array) => {
  const contagem = {};

  array.forEach((obj) => {
    const box = obj.pkI_BoxNumber;
    contagem[box] = contagem[box] ? contagem[box] + 1 : 1;
  });

  const resultado = Object.keys(contagem).map((box) => ({
    chave: box,
    valor: contagem[box],
  }));

  return resultado;
};

const somarValores = (lista, atributo, replace) => {
  let sum = 0;

  for (let i = 0; i < lista.length; i++) {
    sum += lista[i][atributo];
  }

  sum = Number(sum.toFixed(2));

  if (replace) {
    sum = sum.toString().replace(".", ",");
  }

  return sum;
};

const getAnoAtual = () => {
  const date = new Date().getFullYear();
  return date;
};

const calculateTotalWeights = (listBox, data) => {
  const totalWeights = [];

  Object.entries(listBox).forEach((outerRow) => {
    let currentBoxTotalWeight = 0;
    const boxCode = outerRow[1].chave;

    for (let i = 0; i < data.length; i++) {
      if (boxCode === data[i].pkI_BoxNumber) {
        currentBoxTotalWeight = Number(data[i].pkB_BoxWeight);
        break;
      }
    }

    Object.entries(data).forEach((innerRow) => {
      if (innerRow[1].pkI_BoxNumber === boxCode) {
        currentBoxTotalWeight += Number(innerRow[1].item_PesoLiquido);
      }
    });

    currentBoxTotalWeight = Number(currentBoxTotalWeight.toFixed(2));

    totalWeights.push({
      boxCode: boxCode,
      boxTotalWeigth: currentBoxTotalWeight,
    });
  });

  return totalWeights;
};

const SectionOne = (data, nameInvoice) => {
  return (
    <View style={[styles.sectionContainer]}>
      <View
        style={[
          styles.section,
          {
            borderWidth: 1,
            borderBottomColor: "black",
            display: "flex",
            flexDirection: "row",
            gap: 3,
            justifyContent: "flex-start",
          },
        ]}
      >
        <View
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: 100,
          }}
        >
          <Image style={styles.logo} src={logo} />
          <Text
            style={{ fontSize: 8, textAlign: "center" }}
            render={({ pageNumber, totalPages }) =>
              `Pág ${pageNumber} de ${totalPages}`
            }
          />
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginTop: "auto",
            marginBottom: "auto",
            justifyContent: "space-between",
            gap: 20,
          }}
        >
          <View style={[styles.sectionTextHeader]}>
            <Text style={styles.text}>Date: </Text>
            <Text style={styles.text}>{getDataFormatBr()} </Text>
          </View>

          <View style={[styles.sectionTextHeader]}>
            <Text style={styles.text}>Packing List No.: </Text>
            <Text style={styles.text}>{data[0].pedidoVenda} </Text>
          </View>

          <View style={[styles.sectionTextHeader]}>
            <Text style={styles.text}>Invoice No.: </Text>
            <Text style={styles.text}>
              {nameInvoice != ""
                ? data[0].pedidoVenda + "/" + nameInvoice
                : data[0].pedidoVenda}
            </Text>
          </View>

          <View style={[styles.sectionTextHeader]}>
            <Text style={styles.text}>Client: </Text>
            <Text style={styles.text}>{data[0].cliente} </Text>
          </View>

          <View style={[styles.sectionTextHeader]}>
            <Text style={styles.text}>Shipment </Text>
            <Text style={styles.text}>{getAnoAtual()} </Text>
          </View>

          <View style={[styles.sectionTextHeader]}>
            <Text style={styles.text}>Shipment No.: </Text>
            <Text style={styles.text}> </Text>
          </View>

          <View style={[styles.sectionTextHeader]}>
            <Text style={styles.text}>AWB/BL: </Text>
            <Text style={styles.text}> </Text>
          </View>

          <View style={[styles.sectionTextHeader]}>
            <Text style={styles.text}>Forwarder: </Text>
            <Text style={styles.text}> </Text>
          </View>

          <View style={[styles.sectionTextHeader]}>
            <Text style={styles.text}>Incoterm: </Text>
            <Text style={styles.text}>{data[0].incoterm1}</Text>
          </View>
        </View>
      </View>
    </View>
  );
};

const SectionTwo = (data) => {
  return (
    <View style={styles.sectionContainer}>
      <View
        style={{
          borderWidth: 1,
          borderBottomColor: "black",
          display: "flex",
          flexDirection: "row",
          gap: 3,
          justifyContent: "space-between",
        }}
      >
        <View
          style={[
            styles.section,
            {
              width: "40%",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 3,
            },
          ]}
        >
          <View>
            <Text style={{ fontSize: 10, fontWeight: "black" }}>
              Shiped To:
            </Text>
          </View>

          <View>
            <Text style={{ fontSize: 10 }}>{data[0].destinatario_Invoice}</Text>
            <Text style={{ fontSize: 10 }}>
              {data[0].endereco_Dest_Invoice}
            </Text>
            <Text style={{ fontSize: 10 }}>{data[0].cidade_Dest_Invoice}</Text>
            <Text
              style={{
                fontSize: 10,
              }}
            >
              {data[0].pais_Dest_Invoice}
            </Text>
          </View>
        </View>

        <View
          style={[
            styles.section,
            {
              width: "20%",
              display: "flex",
              gap: 3,
            },
          ]}
        >
          <View style={styles.sectionTextHeader}>
            <Text style={{ fontSize: 12 }}>Reference:</Text>

            <Text
              style={{
                fontSize: 12,
              }}
            >
              {data[0].pedidoVenda}{" "}
            </Text>
          </View>
        </View>

        <View
          style={[
            styles.section,
            {
              width: "40%",
              display: "flex",
              gap: 3,
            },
          ]}
        >
          <View style={styles.sectionTextHeader}>
            <Text style={{ fontSize: 12 }}>Total # of Boxes:</Text>
            <Text
              style={{
                fontSize: 12,
              }}
            >
              {listBox.length}
            </Text>
          </View>

          <View style={styles.sectionTextHeader}>
            <Text style={{ fontSize: 12 }}>Total # of Pieces: </Text>
            <Text
              style={{
                fontSize: 12,
              }}
            >
              {sumQtde}{" "}
            </Text>
          </View>

          <View style={styles.sectionTextHeader}>
            <Text style={{ fontSize: 12 }}>Total Net Weigth: </Text>
            <Text
              style={{
                fontSize: 12,
              }}
            >
              {sumNetWeight}
            </Text>
          </View>

          <View style={styles.sectionTextHeader}>
            <Text style={{ fontSize: 12 }}>Total Gross Weigth: </Text>
            <Text
              style={{
                fontSize: 12,
              }}
            >
              {totalWeigthPack}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

const Table = (data) => {
  return (
    <View style={styles.table}>
      <View style={styles.tableRow}>
        <Text style={[styles.cell, { width: "8%" }]}>
          <Text style={styles.columnHeaderText}>Box Nº</Text>
        </Text>

        <Text style={[styles.cell, { width: "8%" }]}>
          <Text style={styles.columnHeaderText}>Customer PO</Text>
        </Text>

        <Text style={[styles.cell, { width: "8%" }]}>
          <Text style={styles.columnHeaderText}>Sales Order</Text>
        </Text>

        <Text style={[styles.cell, { width: "8%" }]}>
          <Text style={styles.columnHeaderText}>AGP Part Number</Text>
        </Text>

        <Text style={[styles.cell, { width: "8%" }]}>
          <Text style={styles.columnHeaderText}>Ref. Lote</Text>
        </Text>

        <Text style={[styles.cell, { width: "16%" }]}>
          <Text style={styles.columnHeaderText}>Vehicle/Project</Text>
        </Text>

        <Text style={[styles.cell, { width: "12%" }]}>
          <Text style={styles.columnHeaderText}>Part Descrition</Text>
        </Text>

        <Text style={[styles.cell, { width: "4%" }]}>
          <Text style={styles.columnHeaderText}>Qty. </Text>
        </Text>

        <Text style={[styles.cell, { width: "8%" }]}>
          <Text style={styles.columnHeaderText}>Net Weigth (Kg)</Text>
        </Text>

        <Text style={[styles.cell, { width: "8%" }]}>
          <Text style={styles.columnHeaderText}>Gross Weigth (Kg)</Text>
        </Text>

        <Text style={[styles.cell, { width: "8%" }]}>
          <Text style={styles.columnHeaderText}>Dimensions (cm) </Text>
        </Text>
      </View>

      {!!listBox &&
        Object.entries(listBox).map((outerRow) => {
          let showWeight = false;
          let boxCode = outerRow[1].chave;
          let newBox = "";
          let showBorder = false;
          let totalWeigth = 0;

          return (
            !!data &&
            Object.entries(data).map((innerRow) => {
              for (let i = 0; i < totalWeigthBox.length; i++) {
                if (totalWeigthBox[i].boxCode === innerRow[1].pkI_BoxNumber) {
                  totalWeigth = totalWeigthBox[i].boxTotalWeigth;
                  break;
                }
              }

              if (innerRow[1].pkI_BoxNumber === boxCode) {
                if (newBox !== boxCode) {
                  showWeight = true;
                  newBox = boxCode;
                } else {
                  showWeight = false;
                }

                if (firtBox > 0) {
                  showBorder = true;
                }

                firtBox++;

                return (
                  <View
                    key={innerRow[1].item}
                    style={
                      showBorder && showWeight
                        ? [
                            styles.tableRow,
                            {
                              alignItems: "flex-start",
                              borderBottomWidth: 1,
                              borderTopWidth: 1,
                              borderColor: "black",
                            },
                          ]
                        : [styles.tableRow, { alignItems: "flex-start" }]
                    }
                  >
                    <Text style={[styles.cell, { width: "8%" }]}>
                      {showWeight ? Number(outerRow[0]) + Number(1) : null}
                    </Text>

                    <Text style={[styles.cell, { width: "8%" }]}>
                      {innerRow[1].pedido_Cliente}
                    </Text>

                    <Text style={[styles.cell, { width: "8%" }]}>
                      {innerRow[1].pedidoVenda}
                    </Text>

                    <Text style={[styles.cell, { width: "8%" }]}>
                      {innerRow[1].material}
                    </Text>

                    <Text
                      style={[styles.cell, { width: "8%" }]}
                    >{`EXP${addLeadingZeros(innerRow[1].id, 6)}`}</Text>

                    <Text
                      style={
                        showWeight
                          ? [styles.cell, { width: "16%", paddingBottom: 6 }]
                          : [styles.cell, { width: "16%" }]
                      }
                    >
                      {innerRow[1].veiculo}
                    </Text>

                    <Text style={[styles.cell, { width: "12%" }]}>
                      {innerRow[1].peca}
                    </Text>

                    <Text style={[styles.cell, { width: "4%" }]}>
                      {innerRow[1].qtde}
                    </Text>

                    <Text style={[styles.cell, { width: "8%" }]}>
                      {innerRow[1].item_PesoLiquido}
                    </Text>

                    <Text style={[styles.cell, { width: "8%" }]}>
                      {showWeight ? totalWeigth : null}
                    </Text>

                    <Text style={[styles.cell, { width: "8%" }]}>
                      {showWeight ? innerRow[1].pkB_BoxSize : null}
                    </Text>
                  </View>
                );
              }
            })
          );
        })}
    </View>
  );
};

const MyDocument = ({ data, lenguage, nameInvoice }) => {
  sumValues(data);

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View fixed>
          {SectionOne(data, nameInvoice)}

          {SectionTwo(data)}
        </View>

        {Table(data)}

        <View style={styles.fixedFooter} fixed>
          <Text>
            AGP in compliance with current environmental regulations in Peru
            manages the recycling of different waste generated during the
            production process (glass, plastics, cardboard, and wood). It must
            be taken into account that AGP products are not recyclable.
            Therefore, they must be disposed of properly in a Sanitary Landfill
            or disposed of according to the environmental standard in force in
            your country.
          </Text>

          <Text style={{ backgroundColor: "#a9a9a9" }}>
            Our BRG Handling and Installation Recommendations Manual, which
            includes the applicable warranty terms and conditions, can be found
            within each product box. It is the buyer's responsibility to ensure
            that the product is used correctly, stored, handled, and installed
            properly. AGP is not responsible for misuse of its products.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

// Função para gerar o PDF

const generatePDF2 = async (invoice, lenguage, codeInvoice, nameInvoice) => {
  const pdfBlob = await pdf(
    <MyDocument
      data={invoice}
      codeInvoice={codeInvoice}
      lenguage={lenguage}
      nameInvoice={nameInvoice}
    />
  ).toBlob();

  const url = URL.createObjectURL(pdfBlob);

  window.open(url, "_blank");

  URL.revokeObjectURL(url);
};

export default generatePDF2;
